var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"5","height":"5","stroke":"#222222","key":0}),React.createElement("rect",{"x":"0.5","y":"9.5","width":"5","height":"5","stroke":"#222222","key":1}),React.createElement("rect",{"x":"9.5","y":"0.5","width":"5","height":"5","stroke":"#222222","key":2}),React.createElement("rect",{"x":"9.5","y":"9.5","width":"5","height":"5","stroke":"#222222","key":3})]);
}

Grid.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Grid;

Grid.default = Grid;
